import { render, staticRenderFns } from "./ProjectWizzard.vue?vue&type=template&id=9532d3b6&"
import script from "./ProjectWizzard.vue?vue&type=script&lang=js&"
export * from "./ProjectWizzard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports